// Main constants
export var ROUTE_CHECK_DURATION = 30000;

// Calculation route weight constants
export var BASE_WEIGHT_FACTOR = 0.1;
export var WEIGHT_REDUCE_FACTOR = 0.03;
export var FORCE_REPLACE_WEIGHT = 5;
export var BEST_THAN_CURRENT_WEIGHT = 25;
export var CURRENT_WORSE_THAN_PREV_WEIGHT = 30;

// Record items' constants
export var ERROR_SPAN_MAX = 15000;
export var BASE_SPAN = 100;
export var RECORD_SIZE = 3;